import { Link } from "react-router-dom";
import UserImageCircle from "../../components/UserImageCircle";
import React from "react";


const TeamProposalTab = ({ team, backBtnTitle }) => {
    const { talent_opps, proposal_path } = team.job_candidate;
    return (
        <div className="p-8 flex flex-col gap-4">
            {proposal_path && (
                <div>
                    <h3 className="proposal-tab-header pb-1">
                        Proposal
                    </h3>

                    <Link className="details-link btn btn-link-primary text-sm !inline" to={proposal_path} target={"_blank"}>
                        View Proposal
                    </Link>
                </div>
            )}

            <div>
                <h3 className="proposal-tab-header pb-1">
                    Role Summary
                </h3>

                <div className="divide-y divide-gray-200">
                    {talent_opps.map(opp => {
                        const rates = opp.disciplines.map(item => item.hourly_rate);
                        const max = Math.max(...rates)
                        const min = Math.min(...rates);
                        const billRate = min === max ? TB.formatCurrency(max) : `${TB.formatCurrency(min)}-${TB.formatCurrency(max)}`;

                        return (
                            <div key={opp.id} className="py-2.5">
                                <div className="flex items-center justify-between gap-4">

                                    <div className="flex items-center gap-4">

                                        <UserImageCircle user={opp.user} size={60} className="img-grayscale profile-image m-auto" />
                                        <div>
                                            <div className="flex items-center gap-6">
                                                <p>{opp.user.firstNamePlusInitial()}</p>

                                                <p className="text-xs">Avg Bill Rate: <span className="font-bold">{billRate}/hr</span></p>
                                            </div>

                                            <div className="member-user-title pt-1">
                                                {opp.disciplines.map(discipline => (
                                                    <p key={discipline.id} className="bg-wripplePrimaryPaleGreen text-xs rounded-full px-2 inline-block">{discipline.name}</p>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <Link
                                        target="_blank"
                                        to={`/team-profiles/${team.id}/talent-profiles/${opp.user.id}`}
                                        className="btn btn-link-primary !inline text-sm"
                                    >
                                        View Profile
                                    </Link>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default TeamProposalTab;